export default {
  velt: {
    openPanel: 'Открыть панель комментариев',
    closePanel: 'Закрыть панель комментариев',
    panel: 'Панель комментариев',
    tabs: 'Вкладки панели комментариев',
    comments: 'Комментарии',
    settings: 'Настройки и разрешения',
    dragOrTapComment: 'Перетащите, чтобы добавить комментарий, или нажмите, чтобы просмотреть комментарии',
    assignComment: 'Назначить комментарий',
    markAsUnread: 'Отметить как непрочитанное',
    markAsRead: 'Отметить как прочитанное',
    unsubscribe: 'Отписаться',
    subscribe: 'Подписаться',
    deleteThread: 'Удалить обсуждение',
    editComment: 'Редактировать комментарий',
    emptyPlaceholder: 'Оставьте отзыв, задайте вопрос или напишите заметку для участников команды',
    searchPlaceholder: 'Поиск комментариев',
    commentPlaceholder: 'Комментарий к {page}',
    replyPlaceholder: 'Ответить....',
    filterPages: 'Страницы',
    filterAuthor: 'Автор',
    filterTagged: 'Отмеченные',
    statusOpen: 'Открыт',
    statusResolved: 'Решён',
    anonymous: 'Аноним',
    settingsPanel: {
      title: 'Кто может комментировать?',
      everyoneLabel: 'Все',
      restrictedLabel: 'Только приглашённые участники',
      emailsLabel: 'Электронные письма',
      emailsPlaceholder: 'Добавьте адрес и нажмите Enter',
    },
  },
}
